import { createSelector } from 'reselect'

export const getLayoutIds = (state, props) => {
  return state['view-home'].view.layouts
}

export const getLayoutsById = (state, props) => {
  return state['view-home'].layouts.byId
}

export default createSelector(
  [getLayoutIds, getLayoutsById],
  (layoutIds, layoutsById) =>
    layoutIds
      .map(id => layoutsById[id])
      .sort((a, b) => a.position - b.position)
)
